import c from 'classnames';
import React from 'react';

import { TextColor, Typography } from '@repo/ui';

import { SLIDE_BACKGROUND_COLORS } from '../slideBackgroundColors';

import background from 'assets/images/summary/first-look/dont_worry.svg';

import { KitType } from '@repo/types';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import styles from './DontWorry.module.scss';
import slideStyles from './Slides.module.scss';

export const DontWorry: React.FC = () => {
  const { currentKit } = useCurrentKitAndTinyAccount();
  const isVaginal = currentKit?.sampling_type === KitType.VAGINAL;

  return (
    <div
      className={c(slideStyles.slideWrapper, styles.slideContainer)}
      style={{ backgroundColor: SLIDE_BACKGROUND_COLORS.dontWorry }}
    >
      <div className={styles.contentContainer}>
        <Typography
          variant='heading-2xl'
          color={TextColor.GREEN}
          weight='medium'
        >
          Don't worry!
        </Typography>
        <Typography variant='heading-l'>
          You can improve your {isVaginal ? 'vaginal microbiome' : 'gut'}{' '}
          through diet, lifestyle changes and supplementation!
        </Typography>
      </div>
      <img src={background} className={styles.backgroundImg} />
    </div>
  );
};
